import { combineReducers } from 'redux';

import availableDays from './availableDays';

export default combineReducers({
  availableDays,
});
